import { createApp, configureCompat } from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { createPinia } from 'pinia';
import 'vue3-toastify/dist/index.css';
import Vue3Toastify from 'vue3-toastify';
import HighchartsVue from 'highcharts-vue';
import App from './App.vue';
import router from './router';
import BaseCard from './components/UI/BaseCard.vue';

const app = createApp(App);

app.use(router);
const pinia = createPinia();
app.use(pinia);
app.use(BootstrapVue);
app.use(IconsPlugin);
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: 'bottom-center',
  theme: 'light',
  limit: 3,
});
app.use(HighchartsVue);
app.component('base-card', BaseCard);

configureCompat({
  MODE: 2,
});

app.mount('#app');
